exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ct-line {\n  stroke: gray !important;\n  stroke-width: 2px;\n}\n\n.ct-point {\n  stroke: none !important;\n}\n\n.ct-percentile-label {\n  pointer-events: none !important;\n}\n\n.ct-series-o .ct-point {\n  stroke: #FF6363 !important;\n}\n\n.ct-series-o .ct-line {\n  stroke: #FF6363 !important;\n  stroke-width: 3px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./client/src/styles/chartistOverrides.global.css
// module id = 516
// module chunks = 0